import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=36daf11c&lang=pug&"
import script from "./Main.vue?vue&type=script&lang=coffee&"
export * from "./Main.vue?vue&type=script&lang=coffee&"
import style0 from "./Main.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports